import { render, staticRenderFns } from "./SumupScoreAverageList.vue?vue&type=template&id=0ac94d1b&"
import script from "./SumupScoreAverageList.vue?vue&type=script&lang=ts&"
export * from "./SumupScoreAverageList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports